"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_f27550e9{overflow-y:auto;max-height:inherit;height:inherit;-webkit-overflow-scrolling:touch}.stickyContainer_f27550e9{overflow:hidden;position:absolute;pointer-events:none}.stickyAbove_f27550e9,.stickyBelow_f27550e9{position:absolute;pointer-events:auto;width:100%;z-index:1}.stickyAbove_f27550e9{top:0}@media screen and (-ms-high-contrast: active){.stickyAbove_f27550e9{border-bottom:1px solid WindowText}}.stickyBelow_f27550e9{bottom:0}@media screen and (-ms-high-contrast: active){.stickyBelow_f27550e9{border-top:1px solid WindowText}}\n" }]);
exports.root = "root_f27550e9";
exports.stickyContainer = "stickyContainer_f27550e9";
exports.stickyAbove = "stickyAbove_f27550e9";
exports.stickyBelow = "stickyBelow_f27550e9";
//# sourceMappingURL=ScrollablePane.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/ScrollablePane/ScrollablePane.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/ScrollablePane/ScrollablePane.scss.js
// module chunks = 1